<template>
    <div class="main">

        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">
            <!-- 圖台 -->
            <div id="map" class="gis-basic">
                <!-- 左上鄉鎮市區選單 -->
                <div class="legend w3-round-large" style="width: 205px;padding-bottom: 10px;padding-left: 20px;padding-right: 20px;">
                    <h4 class="legendTitle">雲林縣鄉鎮市區</h4>
                    <v-select class="global-descript" v-model="input.town.value" :options="input.town.list" label="text"></v-select>
                </div>
                <!-- 左上定位功能 -->
                <div class="legend w3-round-large" style="left: unset;right: 0.5rem;width: 32px; background: #EEEEEE" @click="onLocation">
                  <i class="fa fa-location-arrow" aria-hidden="true" style="padding: 0.5rem; font-size: 1rem;"></i>
                </div>
            </div>
        </div>

        <!-- 彈出視窗(據點清單) -->
        <ModalWindow
            :show="modal.location.show"
            :textTitle="modal.location.title"
            :maxWidth="'720px'"
            @ClickClose="modal.location.show = false;">

            <!-- 清單 --> 
            <OptionsGroup>
                <template v-for="(data, index) in modal.location.list">
                    <OptionsItem :key="`item-${index}`" classIcon="fa fa-map-marker" :textTitle="'地號 : ' + data.SitesecNumber + '(' + data.Code + ')'" @clickItem="getCurlFacturerSelect2(data)" />
                    <hr v-if="index !== modal.location.list.length - 1" :key="`divider-${index}`" />
                </template>
            </OptionsGroup> 

        </ModalWindow>

        <!-- 彈出視窗(據點感測值) -->
        <ModalWindow
            :show="modal.location_info.show"
            :textTitle="modal.location_info.title"
            :maxWidth="'720px'"
            @ClickClose="modal.location_info.show = false;">

            <p class="global-descript" style="text-align:end;">
                感測時間: {{ modal.location_info.value.time.replace("T", " ").split(".")[0] }}
            </p>

            <!-- 溫度 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.temperature }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(modal.location_info.value.temperature) }} {{ station.unit.temperature }}</b>
                    </li>
                </ul>
            </div>

            <!-- 雨量 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.rainfall }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(modal.location_info.value.rainfall) }} {{ station.unit.rainfall }}</b>
                    </li>
                </ul>
            </div>

            <!-- 相對溼度 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.relative_humidity }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(modal.location_info.value.relative_humidity) }} {{ station.unit.relative_humidity }}</b>
                    </li>
                </ul>
            </div>

            <!-- 風速 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.wind_speed }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(modal.location_info.value.wind_speed) }} {{ station.unit.wind_speed }}</b>
                    </li>
                </ul>
            </div>

            <!-- 風向 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.wind_direction }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(modal.location_info.value.wind_direction) }} {{ station.unit.wind_direction }}</b>
                    </li>
                </ul>
            </div>

            <!-- 日射量 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ station.field.solar_irradiance }}</li>
                    <li class="global-descript">
                    <b>{{ formatValue(modal.location_info.value.solar_irradiance) }} {{ station.unit.solar_irradiance }}</b>
                    </li>
                </ul>
            </div>
        </ModalWindow>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import Map from 'ol/Map';
import View from 'ol/View';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

import { XYZ,
         Vector as VectorSource,
        } from "ol/source";

import { fromLonLat,
        } from "ol/proj";

import { Tile,
         Vector as VectorLayer,
        } from "ol/layer";
import GeoJSON from "ol/format/GeoJSON";

import {
        Style,
        Icon,
        Fill,
        Stroke,
        Text
        } from "ol/style";
import { defaults as defaultControls } from 'ol/control';
import ModalWindow from '@/components/pwa/ModalWindow.vue'
import OptionsGroup from '@/components/pwa/OptionsGroup.vue'
import OptionsItem from '@/components/pwa/OptionsItem.vue'
export default {
    created() {
        window.vue = this;
        //先將圖表設定成 null，否則會有頁面切換回來，圖表無法呈現，沒有反應的問題。
        window.ChartIntelligenceCropArea = null;
        window.ChartIntelligenceCropArea2 = null;

        if(!window.checkLogin()){ window.setPage("login");}
    },
    components: {
        Header,
        ModalWindow,
        OptionsGroup,
        OptionsItem
    },
    data(){
        return {

            //api 據點清單
            apiCurlFacturerLocationInfo: (data) => this.userRequest.post("/API/Default/CurlFacturerLocationInfo", data),

            //api 據點感測值
            apiCurlFacturerSelect2: (data) => this.userRequest.post("/API/Default/CurlFacturerSelect2", data),

            //表單物件
            input:{
                //鄉鎮市區
                town:{
                    text:"鄉鎮市區",
                    value:{value:"P00",text:"請選擇鄉鎮市區"},
                    placeholder:"請選擇鄉鎮市區",
                    list:[
                        {value:"P00",text:"請選擇鄉鎮市區"},
                        {value:"P01",text:"斗六市"},
                        {value:"P02",text:"斗南鎮"},
                        {value:"P03",text:"虎尾鎮"},
                        {value:"P04",text:"西螺鎮"},
                        {value:"P05",text:"土庫鎮"},

                        {value:"P06",text:"北港鎮"},
                        {value:"P07",text:"古坑鄉"},
                        {value:"P08",text:"大埤鄉"},
                        {value:"P09",text:"莿桐鄉"},
                        {value:"P10",text:"林內鄉"},

                        {value:"P11",text:"二崙鄉"},
                        {value:"P12",text:"崙背鄉"},
                        {value:"P13",text:"麥寮鄉"},
                        {value:"P14",text:"東勢鄉"},
                        {value:"P15",text:"褒忠鄉"},

                        {value:"P16",text:"臺西鄉"},
                        {value:"P17",text:"元長鄉"},
                        {value:"P18",text:"四湖鄉"},
                        {value:"P19",text:"口湖鄉"},
                        {value:"P20",text:"水林鄉"}
                    ],
                },
            },

            title: "雲林微氣候觀測站",

            //雲林微氣候觀測站說明
            station:{
                title:"微氣候感測器資料整合",
                descript:"本專區即時介接中央氣象局觀測資料，提供雲林縣各鄉鎮之溫度、降雨量、風速風向、日照時數等氣象資訊，使用者可快速掌握各地即時天氣與未來幾日的氣象預報，以利農事安排與防災規劃。",
                
                //欄位名稱
                field:{
                    //鄉鎮市區
                    town:"鄉鎮市區",
                    //地段
                    sitesec_name:"地段",
                    //地號
                    sitesec_number:"地號",
                    //溫度
                    temperature:"溫度",
                    //雨量
                    rainfall:"雨量",
                    //相對濕度
                    relative_humidity:"相對濕度",
                    //風速
                    wind_speed:"風速",
                    //風向
                    wind_direction:"風向",
                    //日射量
                    solar_irradiance:"日射量",
                },
                //單位
                unit:{
                    //鄉鎮市區
                    town:"",
                    //地段
                    sitesec_name:"",
                    //地號
                    sitesec_number:"",
                    //溫度
                    temperature:"°C",
                    //雨量
                    //rainfall:"mm/hr",
                    rainfall:"mm",
                    //相對濕度
                    relative_humidity:"%",
                    //風速
                    wind_speed:"mm",
                    //風向
                    wind_direction:"",
                    //日射量
                    solar_irradiance:"W/m²",
                },
            },

            //OpenLayers 相關物件
            //備註:因為地圖物件，會用到很多變數，所以統一，所有的地圖變數都宣告在 openLayers 物件內
            //備註:如果沒有特定的初始值，統一用null以方便外部去做判別
            openLayers:{
                //地圖物件
                Map:null,
                //地圖預設值
                Default:
                {
                    //容器的ID
                    Target:'map',
                    //緯度
                    CenterLat:23.652574754046682,
                    //經度
                    CenterLng:120.36276133502504,
                    //TWD97X
                    TWD97X:184992.53879376827,
                    //TWD97Y
                    TWD97Y:2616692.675353226,
                    //視野(Zoom)
                    Zoom:10,
                },
                //圖層
                Layer:{

                    Tile:{
                        //正射影像圖(通用)
                        PHOTO2:null,
                        //臺灣通用電子地圖(無鐵公路)
                        EMAP9:null,
                        //村里界圖
                        Village:null
                    },
                    //起點
                    Start:null,
                    //據點
                    Point:null,
                },
                //樣式
                Style:{


                    //雲林行政區
                    Point:function(feature)
                    {
                        const _this = window.vue._data;

                        // 假設數字存在 feature.values_.NUM
                        let number = feature.values_.Count || "0";

                        //目前點選
                        if(_this.openLayers.Select.Point == feature.values_.ID)
                        {
                            return new Style({
                                image: new Icon({
                                    anchor: [0.5, 1],
                                    src: 'static/img/marker.png',
                                    scale: 0.65
                                }),
                                text: new Text({
                                    text: number.toString(),
                                    offsetY: -27,  // 調整位置
                                    font: 'bold 12px sans-serif',
                                    fill: new Fill({
                                        color: '#ffffff'
                                    }),
                                    stroke: new Stroke({
                                        color: '#000000',
                                        width: 3
                                    })
                                })
                            }); 
                        }
                        else
                        {
                            return new Style({
                                image: new Icon({
                                    anchor: [0.5, 1],
                                    src: 'static/img/marker.png',
                                    scale: 0.65
                                }),
                                text: new Text({
                                    text: number.toString(),
                                    offsetY: -27,
                                    font: 'bold 12px sans-serif',
                                    fill: new Fill({
                                        color: '#ffffff'
                                    }),
                                    stroke: new Stroke({
                                        color: '#000000',
                                        width: 3
                                    })
                                })
                            }); 
                        }
                    },

                },

                //目前選擇
                Select:{
                    Point:null,
                },
                //資料數據
                Data:{
                    Point:null,
                },
            },

            //彈出視窗
            modal:{

                //據點清單
                location:{

                    //是否呈現
                    show:false,
                    //標題
                    title:"",
                    //目前選取的索引值
                    index:0
                },

                //據點感測值
                location_info:{

                    //是否呈現
                    show:false,
                    //標題
                    title:"",
                    //目前選取的索引值
                    value:{
                        //名稱
                        name:"易圖開發測試(古坑鄉)",
                        //代碼
                        code:"01",
                        //時間
                        time:"",

                        //鄉鎮市區
                        town:"古坑鄉",
                        //地段
                        sitesec_name:"永昌段",
                        //地號
                        sitesec_number:"78-2",
                        //溫度
                        temperature:"24.3",
                        //雨量
                        rainfall:"0.0",
                        //相對濕度
                        relative_humidity:"80",
                        //風速
                        wind_speed:"5.5",
                        //風向
                        wind_direction:"北北東",
                        //日射量
                        solar_irradiance:"0.01",
                    }
                },
            },
        }
    },
    mounted(){
        window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                            //例如:window.vue._data.map.getCesiumScene().setEnabled(false);

        //初始地圖
        this.initMap();
        this.getLocalInfo();

    },
    watch: {

        "modal.location.show": function(val){
            if(!val){ 
                this.openLayers.Select.Point = -1; 
                this.openLayers.Layer.Point.getSource().changed();
            }
        },
        "input.town.value": function(val){

            switch(val.value){

                case "P01": this.goMap(205140.8233,2622601.056,13); break;
                case "P02": this.goMap(197228.2676,2618657.888,13); break;
                case "P03": this.goMap(191809.1634,2623766.814,13); break;
                case "P04": this.goMap(194769.3145,2630711.087,13); break;
                case "P05": this.goMap(185211.2932,2620969.331,13); break;
                case "P06": this.goMap(177945.2347,2610048.846,13); break;
                case "P07": this.goMap(210381.8169,2613611.161,13); break;
                case "P08": this.goMap(191395.0163,2615902.559,13); break;
                case "P09": this.goMap(201997.409,2629612.18,13); break;
                case "P10": this.goMap(210805.394,2628039.454,13); break;
                case "P11": this.goMap(188495.403,2632190.291,13); break;
                case "P12": this.goMap(182120.1156,2630661.979,13); break;
                case "P13": this.goMap(172346.0934,2632129.478,13); break;
                case "P14": this.goMap(174167.6762,2621578.853,13); break;
                case "P15": this.goMap(179807.7938,2623765.879,13); break;
                case "P16": this.goMap(168405.7749,2623882.853,13); break;
                case "P17": this.goMap(181436.479,2615595.41,13); break;
                case "P18": this.goMap(167754.407,2616090.131,13); break;
                case "P19": this.goMap(162339.0381,2605903.415,13); break;
                case "P20": this.goMap(171931.9025,2606694.05,13); break;

            }
        }
    },
    methods: {

        //定位到一開始的位置
        onLocation:function(){

            window.vue.goMapLonLat(this.openLayers.Default.CenterLng,this.openLayers.Default.CenterLat,13);
        },

        //取得地理位置(使用者)
        getLocalInfo:function(){

            window.Browser.GetCurrentPosition(

                //當瀏覽器不支援地理資訊時(程序)
                function()
                {      
                    console.log("當瀏覽器不支援地理資訊時(程序)");
                },
                //當瀏覽器允許存取定理資訊時(程序)
                function(position){
            
                    var Lat = position.coords.latitude;
                    var Lon = position.coords.longitude;
                    window.vue.goMapLonLat(Lon,Lat,13);
                    window.vue.openLayers.Default.CenterLat = Lat;
                    window.vue.openLayers.Default.CenterLng = Lon;
                    window.vue.openLayers.Layer.Start
                    .getSource()
                    .getFeatures()[0]
                    .getGeometry()
                    .setCoordinates(
                        fromLonLat([Lon, Lat])
                    );
                    console.log("當瀏覽器允許存取定理資訊時(程序)");
                },
                //當瀏覽器封鎖存取定理資訊時(程序)
                function()
                {
                    console.log("當瀏覽器封鎖存取定理資訊時(程序)"); 
                }
            )

        },

        // 定位(地圖、中心點)
        goMap:function(aTWD97X,aTWD97Y,aZOOM){

            //解決地圖第一次開啟呈現會有空白的問題
            window.ThreadTool.Delay(function(){

                window.vue.openLayers.Map.updateSize();
        
            },500);
            
            var aTWD97  = [aTWD97X,aTWD97Y];
            this.openLayers.Map.getView().animate({center: this.onTWD97ToXY(aTWD97)}, {zoom: aZOOM});
        },
        // 定位(地圖、中心點)
        goMapLonLat:function(aLon,aLat,aZOOM){

            //解決地圖第一次開啟呈現會有空白的問題
            window.ThreadTool.Delay(function(){

                window.vue.openLayers.Map.updateSize();
        
            },500);

            var aLonLat  = [aLon,aLat];
            this.openLayers.Map.getView().animate({center: this.onLonLatToXY(aLonLat)}, {zoom: aZOOM});
        },

        // (TWD97X,TWD97Y) 轉換成 [X,Y]
        onTWD97ToXY: function(TWD97)
        {
            //回傳 [X,Y]
            TWD97[0] = parseFloat(TWD97[0]);
            TWD97[1] = parseFloat(TWD97[1]);
            return this.onLonLatToXY(window.proj4("EPSG:3826", "EPSG:4326", TWD97));
        },
        // (Lon經度,Lat緯度) 轉換成 [X,Y]
        onLonLatToXY: function(LonLat)
        {
            //回傳 [X,Y]
            LonLat[0] = parseFloat(LonLat[0]);
            LonLat[1] = parseFloat(LonLat[1]);
            return window.ol.proj.fromLonLat(LonLat);
        },
        formatValue(val) {
            // null / undefined
            if (val === null || val === undefined) return '\u00A0';

            // 轉成字串後處理
            const str = val.toString().trim();
            return str === '' ? '\u00A0' : str;
        },

        //啟用遮罩
        enableDefaultLoad:function()
        {
            this.enableMask();
            this.default_load = true;
        },

        //取消遮罩
        disableDefaultLoad:function()
        {
            //暫時先設定延遲，否則watch會重複觸發
            const _this = this;
            window.ThreadTool.Delay(function(){

                _this.disableMask();
                _this.default_load = false;

            },this.delay_ms_api);
        },

        // 初始(地圖)
        initMap: function () {

            const _this = this;
            //正射影像圖(通用)
            this.openLayers.Layer.Tile.PHOTO2 = new Tile({
                minZoom: 7,
                maxZoom: 18,
                source: new XYZ({
                    url: "https://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}"
                }),
            });
            //臺灣通用電子地圖(無鐵公路)
            this.openLayers.Layer.Tile.EMAP9 = new Tile({
                minZoom: 7,
                maxZoom: 18,
                source: new XYZ({
                    url: "https://wmts.nlsc.gov.tw/wmts/EMAP/default/EPSG:3857/{z}/{y}/{x}"
                }),
            });
            //村里界圖
            this.openLayers.Layer.Tile.Village = new Tile({
                minZoom: 7,
                maxZoom: 18,
                source: new XYZ({
                    //縣市界
                    //url: "https://wmts.nlsc.gov.tw/wmts/CITY/default/EPSG:3857/{z}/{y}/{x}"
                    //鄉鎮區界
                    url: "https://wmts.nlsc.gov.tw/wmts/TOWN/default/EPSG:3857/{z}/{y}/{x}"
                    //村里界圖
                    //url: "https://wmts.nlsc.gov.tw/wmts/Village/default/EPSG:3857/{z}/{y}/{x}"
                    //地段外圍圖(後期可以考慮這個，這個直接把地段名稱、地段識別碼(範例:奮起段PD0424)秀出來)
                    //url: "https://wmts.nlsc.gov.tw/wmts/LANDSECT/default/EPSG:3857/{z}/{y}/{x}"

                }),
            });
            
            //起點
            this.openLayers.Layer.Start = new VectorLayer({
                source: new VectorSource({
                    features: [
                        new Feature({
                            geometry: new Point(
                                fromLonLat([
                                    _this.openLayers.Default.CenterLng,
                                    _this.openLayers.Default.CenterLat
                                ])
                            )
                        })
                    ]
                }),
                style:new Style({
                    image: new Icon({
                        anchor: [0.5, 1],
                        src: 'static/img/point.png', //你的圖示
                        scale: 0.8
                    })
                })
            });
            this.openLayers.Layer.Start.set("LayerId", "openLayers.Layer.Start");

            //據點
            this.openLayers.Layer.Point = this.getStandardVectorPoint({

                style: this.openLayers.Style.Point,
                //source_url: "GeoJSON/cropstation_forecast.geojson",
                source_url: "api/API/Default/CurlFacturerLocation",
                onLoad:function(Param){

                    var mResponseText = Param.XMLHttpRequest.responseText;
                    //若坐標系是TWD97請用這個
                    //var mFeatures = (new ol.format.GeoJSON()).readFeatures(mResponseText);

                    //若坐標系是經緯度請用這個
                    console.log(JSON.parse(mResponseText));
                    //console.log(Param.Projection);
                    var mFeatures = (new GeoJSON()).readFeatures(JSON.parse(mResponseText),{ featureProjection: Param.Projection });
                    _this.openLayers.Layer.Point.getSource().addFeatures(mFeatures);

                }
            });
            this.openLayers.Layer.Point.set("LayerId", "openLayers.Layer.Point");

            //圖台
            this.openLayers.Map = new Map({
                target: _this.openLayers.Default.Target,
                layers: [
                    //臺灣通用電子地圖(無鐵公路)
                    this.openLayers.Layer.Tile.EMAP9,
                    //村里界圖
                    this.openLayers.Layer.Tile.Village,
                ],
                view: new View({
                    minZoom: 7,
                    maxZoom: 18,
                    center: fromLonLat([_this.openLayers.Default.CenterLng, _this.openLayers.Default.CenterLat]),
                    zoom: _this.openLayers.Default.Zoom
                }),
                controls: defaultControls({
                    zoom: false // 關閉縮放按鈕
                })
            });

            this.openLayers.Map.addLayer(this.openLayers.Layer.Start);
            this.openLayers.Map.addLayer(this.openLayers.Layer.Point);

            /** 註冊監聽事件-當滑鼠單擊時 */
            this.openLayers.Map.on('click', function (e) {

                var pixel = e.pixel;
                var click_event = [];

                //取得所以被觸發的圖層，並將它堆疊再一起
                _this.openLayers.Map.forEachFeatureAtPixel(pixel, function(feature, layer)
                {
                    click_event.push({feature:feature,layer:layer});
                });

                if(click_event.length > 0)
                {
                    //僅取第一個被觸發的圖層
                    var mLayer = click_event[0].layer;
                    var mFeature = click_event[0].feature;
                    var mLayerId = mLayer.get("LayerId");

                    switch(mLayerId){
                        case 'openLayers.Layer.Point':
                            _this.openLayers.Select.Point = mFeature.values_.ID;
                            _this.modal.location.title = mFeature.values_.Town + "-" + mFeature.values_.SitesecName;
                            _this.openLayers.Layer.Point.getSource().changed();
                            _this.getCurlFacturerLocationInfo({

                                Town:mFeature.values_.Town,
                                SitesecName:mFeature.values_.SitesecName,
                                LatSitesec:mFeature.values_.LatSitesec,
                                LngSitesec:mFeature.values_.LngSitesec
                            });
                        break;
                        default:
                    }
                }

            });

            /** 註冊監聽事件-當滑鼠放開時 */
            this.openLayers.Map.on('moveend', function (e) {

                console.log(e);
                window.vue.valueProcessZOOM = window.vue.openLayers.Map.getView().getZoom();
            });

        },
        //切換圖層(state=true 加入地圖、state=false 從地圖移除)
        switchLayer: function(layer,state){

            if(state)
            {
                this.openLayers.Map.addLayer(layer);
            }
            else
            {
                this.openLayers.Map.removeLayer(layer);
            }
        },
        //取得 圖層-點
        getStandardVectorPoint:function(option){

            if(option == undefined || option == null){ option = {};  }

            /** 圖層樣式 */
            if(option.style == undefined || option.style == null){ option.style = null;  }
            /** 資料來源網址 */
            if(option.source_url == undefined || option.source_url == null){ option.source_url = "";  }
            /** 資料來源格式 */
            if(option.source_format == undefined || option.source_format == null){ option.source_format = new GeoJSON();  }
            /** 資料投影 */
            if(option.source_projection == undefined || option.source_projection == null){ option.source_projection = "EPSG:4326";  }
            
            var mVector = new VectorLayer({

                style: option.style,
                source: new VectorSource({

                format: new GeoJSON(),
                projection: option.source_projection,
                loader: function (sourceExtent, resolution, projection) {
                    
                    var mXMLHttpRequest = new XMLHttpRequest();
                    mXMLHttpRequest.open('GET', option.source_url);
                    mXMLHttpRequest.onerror = option.onError;
                    mXMLHttpRequest.onload = function () {

                    if (mXMLHttpRequest.status == 200) 
                    {
                        var Param = {

                        XMLHttpRequest:mXMLHttpRequest,
                        SourceExtent:sourceExtent,
                        Resolution:resolution,
                        Projection:projection
                        }

                        option.onLoad(Param);
                    } 
                    else 
                    {
                        option.onError();
                    }

                    }
                    mXMLHttpRequest.send();
                }

                })

            });

            return mVector;
        },

        //取得據點清單
        getCurlFacturerLocationInfo(data) {
        this.apiCurlFacturerLocationInfo(data)
            .then((res) => {

                var list = JSON.parse(res.data);
                this.modal.location.list = [];
                this.modal.location.list = list;
                this.modal.location.show = true;
                console.log(list);
            })
            .catch((err) => {
                console.log(err);
            });
        },

        //取得據點感測值
        getCurlFacturerSelect2(data) {
            this.enableDefaultLoad();
            this.apiCurlFacturerSelect2(data)
                .then((res) => {

                    var data = JSON.parse(res.data);
                    this.disableDefaultLoad();
                    if(data.length > 0)
                    {
                        //識別碼
                        this.modal.location_info.value.id = data[0].ID;
                        //名稱
                        this.modal.location_info.value.name = data[0].Name;
                        //代碼
                        this.modal.location_info.value.code = data[0].Code;
                        //時間
                        this.modal.location_info.value.time = data[0].CreateTime;
                        //鄉鎮市區
                        this.modal.location_info.value.town = data[0].Town;
                        //地段
                        this.modal.location_info.value.sitesec_name = data[0].SitesecName;
                        //地號
                        this.modal.location_info.value.sitesec_number = data[0].SitesecNumber;
                        //溫度
                        this.modal.location_info.value.temperature = data[0].TemperatureValue;
                        //雨量
                        this.modal.location_info.value.rainfall = data[0].RainfallValue;
                        //相對濕度
                        this.modal.location_info.value.relative_humidity = data[0].RelativeHumidityValue;
                        //風速
                        this.modal.location_info.value.wind_speed = data[0].WindSpeedValue;
                        //風向
                        this.modal.location_info.value.wind_direction = data[0].WindDirectionValue;
                        //日射量
                        this.modal.location_info.value.solar_irradiance = data[0].SolarIrradianceValue;
                        //溫室
                        this.modal.location_info.value.green_house = data[0].GreenHouse;
                        //網室
                        this.modal.location_info.value.net_house = data[0].NetHouse;
                        //露天田地
                        this.modal.location_info.value.open_field = data[0].OpenField;

                        
                        if(this.modal.location_info.value.sitesec_number != '無')
                        {
                            this.modal.location_info.title = this.modal.location_info.value.town + ' ' + this.modal.location_info.value.sitesec_name + ' ' + this.modal.location_info.value.sitesec_number;

                        }else{

                            this.modal.location_info.title = this.modal.location_info.value.town + ' ' + this.modal.location_info.value.sitesec_name 
                        }

                        if(this.modal.location_info.value.green_house == "1"){ this.modal.location_info.title += "(溫室)"; }
                        if(this.modal.location_info.value.net_house == "1"){ this.modal.location_info.title += "(網室)"; }
                        if(this.modal.location_info.value.open_field == "1"){ this.modal.location_info.title += "(露天田地)"; }

                        this.modal.location_info.show = true;

                    }
                    
                    console.log(data);
                })
                .catch((err) => {
                    this.disableDefaultLoad();
                    console.log(err);
                });
        },        
    }
}
</script>
<style>

    #map {
        width: 100%;
        height: 100vh;
        min-height: 70vh;
        background: #FFFFFF;
    }

    .table-tr {

        background: #1D976C;
        color: #FFFFFF;
    }

    .table-td-single {

        background: #ecfff8;
        color: #000000;
    }

    .table-td-double {

        background: #99D0BC;
        color: #000000;
    }

</style>
